module.exports = __webpack_public_path__ + "static/media/loyalty.46eadc43.svg";